// src/data/adList.js

const AD_LIST_RAW = [
  { slug: "chl", title: "ChatoraHack Lottery", url: "/" },
  // { slug: "luck", title: "運気アップ・風水・厄除け", url: "/" },
  // { slug: "travel", title: "パワースポット旅行", url: "/" },
  // { slug: "health", title: "健康食品・サプリ", url: "/" },
  // { slug: "cosmetics", title: "化粧品・コスメ", url: "/" },
];

// 指定されたサイズ用の配列を組み立てるヘルパー
const createAdGroup = (size) => {
  return AD_LIST_RAW.map((ad, index) => ({
    id: index + 1,
    src: `/images/ads/banner-${ad.slug}-${size}.png`,
    alt: ad.title,
    url: ad.url,
  }));
};

// 呼び出し側が「AD_LIST.BANNERS」のように選べるオブジェクトにしてエクスポート
export const AD_LIST = {
  BANNERS: createAdGroup("728x90"),
  AFFILIATE: createAdGroup("728x60"),
  // ANCHOR: createAdGroup("0x0"),
  RECTANGLE: createAdGroup("300x250"),
  WIDESKYSCRAPER: createAdGroup("160x600"),
  SQUARE: createAdGroup("300x350"),
};
